module.exports = __webpack_public_path__ + "media/images/ic_aibaba-b1b587c37836c1b87b3152d39b060b49.svg";